import {MailboxStep} from './mailbox-configurator.store';

export interface Mailbox {
	id: string
	created_at: string
	updated_at: string
	created_by: string
	updated_by: string
	tenant_id: string
	tenant_code: string
	mailbox_address: string
	mailbox_alias: string
	mailbox_name: string
	enabled: boolean
	outbound_configuration: OutboundConfiguration
	inbound_configuration: InboundConfiguration
}

export interface MailboxDTO {
	tenant_id: string
	mailbox_name: string
	mailbox_alias: string
	mailbox_address: string
}

export interface OutboundConfiguration {
	id: string
	created_at: string
	updated_at: string
	created_by: string
	updated_by: string
	client: string
	email_configuration_alias: string
	email_type: string
	email_host: string
	smtp_port: string
	socket_factory_port: string
	socket_factory_class: string
	starttls_enable: string
	mail_debug: string
	transport_protocol: string
	email_auth: string
	email_mime_charset: string
	email_user_name: string
	email_from_address: string
	email_from_name: string
}

export interface InboundConfiguration {
	id: string
	created_at: string
	updated_at: string
	created_by: string
	updated_by: string
	client: string
	imap_host: string
	imap_port: number
	username: string
	password: string
	protocol: string
	folder: string
	idle_enabled: boolean
	ssl_enabled: boolean
	start_tls_enabled: boolean
}

export interface InboundDTO {
	client: MailboxProvider
	email: string
	username: string
	password: string
	host?: string
	folder?: string
	imap_port?: number
	protocol?: string
	idle_enabled?: boolean
	ssl_enabled?: boolean
	start_tls_enabled?: boolean
}

export interface InboundListenerDTO {
	mailbox_id: string
	inbound_configuration_id: string
}

export interface OutboundDTO {
	client: MailboxProvider
	email: string
	email_configuration_alias: string
	username: string
	password: string
	host: string
	from_name: string
	from_address: string
	smtp_port: string
	socket_factory_port: string
	socket_factory_class: string
	starttls_enable: string
	mail_debug: string
	transport_protocol: string
	email_auth: string
	email_mime_charset: string
}

export type MailboxProvider = 'GMAIL' | 'ARUBA' | 'AWS_WORKMAIL' | 'CUSTOM';

export const MAILBOX_PROVIDERS_OPTIONS = [
	{label: 'Gmail', value: 'GMAIL'},
	{label: 'Aruba', value: 'ARUBA'},
	{label: 'AWS WorkMail', value: 'AWS_WORKMAIL'},
	{label: 'Personalizzata', value: 'CUSTOM'}
]

export const MAILBOX_STEPS: Record<MailboxStep, number> = {
	INBOUND: 1,
	OUTBOUND: 2,
	REVIEW: 3
}
